import styled from "styled-components";
import ArrowRightIcon from "../../../../../../assets/createEnvAssets/ArrowRightIcon";
import ArrowDownIcon from "../../../../../../assets/createEnvAssets/ArrowDownIcon";

const ReadMoreToggleStyle = styled.div`
  color: #EC407A;
  cursor: pointer;
  font-size: medium;
  margin-right: 4px;
  margin-top: -4px;
`;

const BluePrintDescription = styled.div`
  white-space: pre-wrap;
  display: flex;
  font-size: smaller;
  padding: 4px 35px;
`;


const ReadMore = (props) => {
    const text = props.children;
    const {expanded, setExpanded} = props;
    const toggleReadMore = () => {
        setExpanded(!expanded);
    };
    return (
        <BluePrintDescription>
            <ReadMoreToggleStyle  onClick={toggleReadMore} className="read-or-hide">
                {expanded ? <ArrowRightIcon/> : <ArrowDownIcon/>}
            </ReadMoreToggleStyle>
            <div  className={"text"} onClick={toggleReadMore}>
                {expanded ? text.slice(0, 100) + "..." : text}
            </div>

        </BluePrintDescription>
    );
};

export default ReadMore;
